import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router, ActivatedRoute } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class NotNewEntityGuard implements CanActivate {
  constructor(private router: Router, private activatedRoute: ActivatedRoute) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const isNotNew = route.parent.params['id'] && route.parent.params['id'] !== 'new';

    if (!isNotNew) {
      this.router.navigateByUrl(route.data.redirectTo);
    }

    return isNotNew;
  }
}
